import React, { useState } from 'react';

import { Button, Icon, useToast } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

import { useGetFilePdfUrl } from './useGetFilePdfUrl';

export interface ViewAppointmentSuperbillButtonProps {
  tenantId: string;
  appointmentId: string;
}

export const ViewAppointmentSuperbillButton: React.FC<
  ViewAppointmentSuperbillButtonProps
> = ({ tenantId, appointmentId }) => {
  const { t } = useTranslation();
  const toast = useToast();
  const handlePdf = useGetFilePdfUrl({
    appointmentId,
    tenantId,
    type: 'SUPERBILL',
  });

  const [isOpeningPdf, setIsOpeningPdf] = useState(false);

  const openPdf = async () => {
    const newTab = window.open('about:blank', '_blank');
    setIsOpeningPdf(true);
    const response = await handlePdf();
    if (response.status === 201 && newTab) {
      newTab.location = response.body.pdfUrl;
    } else {
      toast.error(t('appointmentTools.common.preparePdfFailed'));
    }
    setIsOpeningPdf(false);
  };

  return (
    <Button variant="secondary" loading={isOpeningPdf} onClick={openPdf}>
      <Icon name="FileText" size="auto" />
      {t('appointmentTools.billing.superbill')}
    </Button>
  );
};
